import UnitManage from './UnitManage.vue'

UnitManage.install = function(Vue) {
  Vue.component(UnitManage.name, UnitManage)
}

import UnitEdit from './UnitEdit.vue'

UnitEdit.install = function(Vue) {
  Vue.component(UnitEdit.name, UnitEdit)
}

import UnitDetail from './UnitDetail.vue'

UnitDetail.install = function(Vue) {
  Vue.component(UnitDetail.name, UnitDetail)
}

export { UnitManage, UnitEdit, UnitDetail }
